// Persistance des préférences et du consentement (localStorage + backend optionnel).
//
// Permet à l'utilisatrice qui revient de retrouver sa morphologie et ses
// préférences sans tout refaire. Avec son consentement, on envoie aussi
// les réponses au backend Modal pour améliorer la reco (analyse offline).

const KEY_ANSWERS = 'eteka.answers';
const KEY_CONSENT = 'eteka.consent';
const KEY_RESULT = 'eteka.result';

export interface SavedAnswers {
  answers: Record<string, string>;
  measurements: Record<string, number>;
  savedAt: number;
}

export interface SavedResult {
  morphology: string;
  confidence: number;
  savedAt: number;
}

export function saveAnswers(answers: Record<string, string>, measurements: Record<string, number>): void {
  try {
    const data: SavedAnswers = { answers, measurements, savedAt: Date.now() };
    localStorage.setItem(KEY_ANSWERS, JSON.stringify(data));
  } catch { /* localStorage indisponible : on ignore */ }
}

export function loadAnswers(): SavedAnswers | null {
  try {
    const raw = localStorage.getItem(KEY_ANSWERS);
    if (!raw) return null;
    return JSON.parse(raw) as SavedAnswers;
  } catch { return null; }
}

export function saveResult(morphology: string, confidence: number): void {
  try {
    localStorage.setItem(KEY_RESULT, JSON.stringify({ morphology, confidence, savedAt: Date.now() }));
  } catch { /* */ }
}

export function loadResult(): SavedResult | null {
  try {
    const raw = localStorage.getItem(KEY_RESULT);
    if (!raw) return null;
    return JSON.parse(raw) as SavedResult;
  } catch { return null; }
}

export function clearSaved(): void {
  try {
    // Tout le namespace eteka.* (answers, result, consent, et toute clé future)
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith('eteka.')) toRemove.push(k);
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
    // Le consent doit aussi sauter
    localStorage.removeItem(KEY_CONSENT);
  } catch { /* */ }
  try {
    // Purge aussi sessionStorage (sessionId)
    const sessionKeys: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith('eteka.')) sessionKeys.push(k);
    }
    sessionKeys.forEach((k) => sessionStorage.removeItem(k));
  } catch { /* */ }
}

/** État du consentement RGPD/nLPD. */
export function getConsent(): boolean {
  try { return localStorage.getItem(KEY_CONSENT) === 'true'; } catch { return false; }
}

export function setConsent(value: boolean): void {
  try { localStorage.setItem(KEY_CONSENT, value ? 'true' : 'false'); } catch { /* */ }
}
